import { render, staticRenderFns } from "./ProjectAdmin.vue?vue&type=template&id=6da33fb9&"
import script from "./ProjectAdmin.vue?vue&type=script&lang=js&"
export * from "./ProjectAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports